
<nav class="navbar" >
	<ul class="main-routes">
		<li class="route-link"
			*rxFor="let route of routes$;"
			>
			<lib-button [route]=route></lib-button>

			<ul class="sub-routes" 
				*rxIf="route.children"
			>
				<li class="route-link" 
					*rxFor="let child of route.children" 
				>
					<lib-button [route]=child></lib-button>
				</li>				
			</ul>
		</li>
	</ul>
</nav>
